import React from "react";
import { DropdownItemProps } from "./Dropdown.types";
import * as S from "./Item.styles";

/**
 * Item component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown Item component
 */
export const Item = React.forwardRef<HTMLDivElement, DropdownItemProps>(
  function Item({ onClick, children, ...props }, ref) {
    return (
      <S.Item
        onClick={props?.disabled ? undefined : onClick}
        ref={ref}
        {...props}
      >
        {children}
      </S.Item>
    );
  }
);
